// extracted by mini-css-extract-plugin
module.exports = {"nft":"index_nft__53cfg"};